import {Selector} from '@packages/systems/style/selectors';
import {PropertyDeclarationBlock} from '@packages/systems/style/properties';
import {MediaQuery, type Device} from '@packages/systems/style/media-queries';
import type {CSSWriter} from '@packages/systems/style/writers';

export type AnyRuleType = MediaRule | StyleRule;

export class StyleRule {
  selector: Selector;
  block: PropertyDeclarationBlock;

  constructor(selector: Selector, block: PropertyDeclarationBlock) {
    this.selector = selector;
    this.block = block;
  }

  toCSS(writer: CSSWriter) {
    writer.addRule(this);
  }
}

export class MediaRule {
  queries: Array<MediaQuery>;
  rules: Array<StyleRule>;

  constructor(queries: Array<MediaQuery>, rules: Array<StyleRule>) {
    this.queries = queries;
    this.rules = rules;
  }

  isEffective(device: Device): boolean {
    for (const query of this.queries) {
      if (!query.matches(device)) {
        return false;
      }
    }
    return true;
  }

  toCSS(writer: CSSWriter) {
    writer.addRule(this);
  }
}
